import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl, headersDefault } from ".";
import { axiosGetWith429Retry } from "../../services/httpRetry";
import {
  createRequestDedupe,
  SCREEN_ENTRY_THROTTLE_MS,
} from "./requestDedupe";

// 1) Progressx
// Both of these are read on entering the home tab, which Ionic may mount more
// than once, so they are deduped: the second read joins the first rather than
// spending another slice of the rate-limit allowance.
const progressDedupe = createRequestDedupe({
  throttleMs: SCREEN_ENTRY_THROTTLE_MS,
});

export const getHomeProgress = createAsyncThunk(
  "home/getProgress",
  async () =>
    progressDedupe.run(undefined, async () => {
      const res = await axiosGetWith429Retry(
        `${baseUrl}/api/app/home/progress`,
        { headers: headersDefault() },
      );
      return res.data;
    }),
  { condition: () => !progressDedupe.isFresh() },
);

// 2) Widgets
const widgetsDedupe = createRequestDedupe({
  throttleMs: SCREEN_ENTRY_THROTTLE_MS,
});

export const getHomeWidgets = createAsyncThunk(
  "home/getWidgets",
  async () =>
    widgetsDedupe.run(undefined, async () => {
      const res = await axiosGetWith429Retry(
        `${baseUrl}/api/app/home/widgets`,
        { headers: headersDefault() },
      );
      return res.data; // { widgets: [...] }
    }),
  { condition: () => !widgetsDedupe.isFresh() },
);

// 3) Calendar (needs date param)
export const getHomeCalendar = createAsyncThunk(
  "home/getCalendar",
  async ({ date, planMode = "master_club" }, thunkAPI) => {
    const params = `date=${encodeURIComponent(date)}${planMode === "adoc" ? "&plan_mode=adoc" : ""}`;
    const res = await axiosGetWith429Retry(
      `${baseUrl}/api/app/home/calendar?${params}`,
      {
        headers: headersDefault(),
        signal: thunkAPI.signal,
      },
      { retries: 2, baseDelayMs: 700 },
    );
    return res.data;
  },
);
